export const platform = {
  get isDesktop() {
    return typeof window !== 'undefined' && !!(window as any).electronAPI;
  },
  get isWeb() {
    return typeof window !== 'undefined' && !(window as any).electronAPI;
  },
  get hasLocalDB() {
    return this.isDesktop && !!(window as any).electronAPI?.db;
  },
  get isServer() {
    return typeof window === 'undefined';
  },
};
